import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-307c93f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-bar-download" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uk-modal-header downloading-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Downloading Presentation")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downloading-message" }, " Please wait for the download to complete. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "asknicely-icon-loader_static" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_RainModal = _resolveComponent("RainModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass([{ trigger: _ctx.showDownloadButton }, 'dl-presentation']),
      href: "",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["prevent"]))
    }, [
      (_ctx.showDownloadButton)
        ? (_openBlock(), _createBlock(_component_BaseButton, {
            key: 0,
            id: "download-presentation-button",
            variant: "secondary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Download Presentation")
            ], undefined, true),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Download Presentation"))
    ], 2),
    _createVNode(_component_RainModal, {
      id: "download-presentation-modal",
      title: "Download Presentation",
      class: "download-modal",
      "btn-right": "Download",
      show: _ctx.show,
      "allow-click-out": true,
      "footer-top-padding": false,
      onClickRight: _ctx.showDownloading,
      onClose: _ctx.close
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], undefined, true),
      _: 3
    }, 8, ["show", "onClickRight", "onClose"]),
    _createVNode(_component_Modal, {
      show: _ctx.downloading,
      class: "visible"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ], undefined, true),
      _: 1
    }, 8, ["show"])
  ]))
}